import { useCallback } from "react";
import CollectibleVideoPlane from "./CollectibleVideoPlane";
import { useInventory } from "../src/stores/useInventory";

export default function HeavyMachineGun({
  radius = 5,
  scaleMultiplier = 1.5,
  onCollect,
  ...props
}) {
  const setHasHeavyMachineGun = useInventory((state) => state.setHasHeavyMachineGun);
  const setGunMode = useInventory((state) => state.setGunMode);

  const handleCollect = useCallback(() => {
    setHasHeavyMachineGun(true);
    setGunMode(true);
    if (typeof onCollect === "function") {
      onCollect();
    }
  }, [onCollect, setGunMode, setHasHeavyMachineGun]);

  return (
    <CollectibleVideoPlane
      id="HeavyMachineGun"
      videoSrc="/video/heavy_machine_gun.webm"
      radius={radius}
      scaleMultiplier={scaleMultiplier}
      onCollect={handleCollect}
      {...props}
    />
  );
}
